export class Technique {
  id: string = ''
  name: string = ''
  slug: string = ''
  key: string = ''
  children: Technique[] = []

  constructor(data: Partial<Technique> = {}) {
    Object.assign(this, data)
  }

  toObject() {
    return {
      id: this.id,
      name: this.name,
      slug: this.slug,
      key: this.key,
      children: this.children.map(c => c.toObject())
    }
  }

  toQuery() {
    return this.children.map(c => c.toQuery()).join(',')
  }

//
//  toQuery () {
//    const childSeparator = this.children.length ? '-c-' : ''
//    return `${this.id}${childSeparator}${this.children.map(c => c.toQuery()).join('-')}`
//  }

  static formQuery(query: any): Technique | null {
    if (!(query && (typeof query === 'object'))) return null
    if (!(query.children && Array.isArray(query.children))) return null
    return new Technique({
      id: query.id,
      children: query.c.map(c => Technique.formQuery(c))
    })
  }

  static manyFormQuery(query: any): Technique[] {
    if (!(query.techniques && Array.isArray(query.techniques))) return []
    return query.techniques
      .map(t => Technique.formQuery(t))
      .filter(t => !!t)
  }

  static filterByExisting(source: Technique[], selected: Technique[]): Technique[] {
    const mapped: Array<Technique | null> = source.map(s => {
      const found = selected.find(ss => ss.id === s.id)
      if (!found) return null
      found.freshChildren(s.children)
      return found
    })
    return Technique.filterNotNull(mapped)

  }

  static filterNotNull(items: Array<Technique | null>): Technique[] {
    return items.filter(m => !!m) as Technique[]
  }

  freshChildren(sourceItems: Technique[]) {
    this.children = Technique.filterByExisting(sourceItems, this.children)
  }

}
